import { useQuery } from "@tanstack/react-query";
import { QueryKeysEnum } from "../types/QueryKeysEnum";
import { getAccount } from "../generated-api/account";
import { useAccountClient } from "./useAccountClient";

export const useAccount = (
  accountId?: string,
  throwOnError?: boolean | ((error: Error) => boolean),
) => {
  const client = useAccountClient();

  const fetchAccount = async (accountId: string) => {
    const { data } = await getAccount({
      client,
      throwOnError: true,
      path: {
        accountId: accountId ?? "",
      },
    });

    return data;
  };

  const response = useQuery({
    queryKey: [QueryKeysEnum.Account, accountId],
    queryFn: async () => fetchAccount(accountId ?? ""),
    throwOnError,
    enabled: Boolean(accountId),
  });

  return { ...response, asyncFetch: fetchAccount };
};
